;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('CreateCategoryController', CreateCategoryController)

  CreateCategoryController.$inject = [
    // Angular
    '$uibModalInstance',

    // Resolve
    'category'

  ]

  function CreateCategoryController (
    // Angular
    $uibModalInstance,

    // Resolve
    category

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        category: category,

        // Methods
        cancel: cancel,
        saveLine: saveLine
      })
    }

    function saveLine () {
      $uibModalInstance.close(self.category)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
